class ProductMaxQuantityMessage extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.setupListeners()
    this.getShopifyCart()
  }

  async getShopifyCart () {
    try {
      const response = await fetch('/cart.js')
      const data = await response.json()
      this.cartData = data
      this.onAfterRefresh(data.items)
    } catch (error) {
      console.error(error)
    }
  }

  setupListeners () {
    super.setupListeners()

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_UPDATE_ITEM_QUANTITY,
      this.onAfterQuantityUpdate.bind(this),
    )

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_ADD_FROM_FORM,
      this.getShopifyCart.bind(this),
    )

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_UPDATE_REMOVE_ITEM,
      this.getShopifyCart.bind(this),
    )

    window.addEventListener('variant:changed', this.getShopifyCart.bind(this))
  }

  onAfterQuantityUpdate (event) {
    this.cart = event.detail.state

    const itemUpdatedId = this.itemUpdated(event.detail.state)

    const cartItems = event.detail.state.items.filter(
      item => item.product_id === itemUpdatedId,
    )

    this.checkIfProductIsEligible(cartItems)
  }

  onAfterRefresh (cart) {
    const cartItems = cart.filter(
      item =>
        item.product_id ===
        Number(this.dataset.productMaxQuantityMessageProductId),
    )

    this.checkIfProductIsEligible(cartItems)
  }

  checkIfProductIsEligible (cartItems) {
    if (cartItems.length === 0) {
      this.hide()
      return
    }

    let quantity = 0

    for (let index = 0; index < cartItems.length; index++) {
      const element = cartItems[index]
      quantity = quantity + element.quantity
    }

    if (
      Number(this.dataset.productMaxQuantityMessageProductId) !==
      cartItems[0].product_id
    ) {
      return
    }

    const backInStock = document.querySelector('product-bis')
    const backInStockVisible = backInStock && !!backInStock.offsetParent

    quantity >= window.theme.orderLimit && !backInStockVisible
      ? this.show([cartItems[0]])
      : this.hide()
  }

  show (itemUpdated) {
    this.setAttribute('aria-hidden', 'false')
    const customEvent = new CustomEvent('quantity:disable', {
      detail: {
        id: itemUpdated.product_id,
      },
    })

    document.dispatchEvent(customEvent)

    if (!this.externalEls.atc.exists) return

    this.setATCText()
  }

  hide () {
    const customEvent = new CustomEvent('variant:reload')
    window.dispatchEvent(customEvent)

    if (!this.externalEls.atc.exists) return

    this.setAttribute('aria-hidden', 'true')
    if (this.externalEls.atc) {
      this.externalEls.atc.element.disabled = false
    }
  }

  itemUpdated (cart) {
    if (cart.items_added.length > 0) {
      return cart.items_added[0].product_id
    } else if (cart.items_removed.length > 0) {
      return cart.items_removed[0].product_id
    }
  }

  setATCText () {
    this.externalEls.atc.element.querySelector('[data-text]').dataset.text =
      window.theme.strings.maxQuantity
    this.externalEls.atc.element.querySelector('[data-text]').innerText =
      window.theme.strings.maxQuantity
    this.externalEls.atc.element.disabled = true
  }
}

if (!customElements.get('product-max-quantity-message')) {
  customElements.define(
    'product-max-quantity-message',
    ProductMaxQuantityMessage,
  )
}
